import React from 'react';
import { withRouter } from "react-router";
import { Helpers } from '../../core/src/helpers';

import '../css/pdp-hpsa.less';

class CarepackPromo extends React.PureComponent {

    state ={
        mounted: false
    }

    setModalHtml = () => {
        const { aoid } = Helpers.getSearch(this.props.location.search);
        //dont add modal if not in target aoid list
        if(!aoid || !(aoid in this.props.targetAoid)){
            return;
        }
        let hpsaPopup = aoid in this.props.aoidMap ? '<div id="hpsaModal" class="hpsamodal"><div class="hpsamodal-content"><span class="hpsaclose">&times;</span><p><div class="hpsacontent">HP SHOPPING ASSISTANT CARE PACK EXCLUSIVE OFFER</div><div class="hpsabottom">Save 45% with code HPSA33</div><div class="hpsacode">Apply code</div><div class="hpsadisclaimer">Coupon code not applicable with other coupon offers</div></p></div></div>' : '<div id="hpsaModal" class="hpsamodal"><div class="hpsamodal-content"><span class="hpsaclose">&times;</span><p><div class="hpsacontent">HP SHOPPING ASSISTANT CARE PACK EXCLUSIVE OFFER</div><div class="hpsabottom">Save 40% with code HPSAPW25</div><div class="hpsacode">Apply code</div><div class="hpsadisclaimer">Coupon code not applicable with other coupon offers</div></p></div></div>';
        let body = document.getElementsByTagName("BODY")[0];
        body.insertAdjacentHTML('beforeend', hpsaPopup);
        let hpsaspan = document.getElementsByClassName("hpsaclose")[0];
        let hpsamodal = document.querySelector("#hpsaModal");
        let hpsacode = document.querySelector(".hpsacode");
        let openModal = document.querySelector(".purchase-btn");
        let closeModal = document.querySelector(".hpsaclose");
        hpsamodal.onclick = function () {
            Helpers.setCookie("optly_hpsa_cp", true, 1);
            location.href = "https://store.hp.com/webapp/wcs/stores/servlet/AjaxOrderItemDisplayView?langId=-1&catalogId=10051&storeId=10151";
        };

        hpsacode.onclick = function () {
            Helpers.setCookie("optly_hpsa_cp", true, 1);
            location.href = "https://store.hp.com/webapp/wcs/stores/servlet/AjaxOrderItemDisplayView?langId=-1&catalogId=10051&storeId=10151";

        };

        hpsaspan.onclick = function () {
            Helpers.setCookie("optly_hpsa_cp", true, 1);
            hpsamodal.style.display = "none";

        };

        document.querySelector(".hpsaclose").onclick = function () {
            Helpers.setCookie("optly_hpsa_cp", true, 1);
            hpsamodal.style.display = "none";
            location.href = "https://store.hp.com/webapp/wcs/stores/servlet/AjaxOrderItemDisplayView?langId=-1&catalogId=10051&storeId=10151";
        };


        document.querySelector('.purchase-info').onclick = function (e) {

            if (e.target.className !== 'purchase-btn') {
                hpsamodal.style.display = "block";
            }

        }


    }

    componentDidMount() {
        this.setState({mounted: true});
        this.setModalHtml();
    }

    render() {
        const { mounted } = this.state;
        /**Since aoid query parameters aren't available on the server because of edge cache rules
         * We need to wait till the component is mounted before rendering. These prevent hydration anomalies
         */
        if(!mounted){
            return null;
        }
        const { aoid } = Helpers.getSearch(this.props.location.search);
        let coupon = "";
        const value = aoid in this.props.aoidMap ? ((coupon = "HPSA33") && 45) : ((coupon = "HPSAPW25") && 40);
        const promo = ("Great news! Receive a total of {%} off with coupon " + coupon + ". Not combinable with other coupons.").replace(/{(\$)}|{(%)}/g, "$1" + value + "$2");

        if (aoid in this.props.targetAoid) {
            return (<div className="offer-module">
                <p>
                    {promo}
                </p>
            </div>)
        } else {
            return null;
        }
    }

    static defaultProps = {
        // aoidMap contains skus that are in-warranty
        aoidMap: {
            "97289": 1,
            "178775": 1,
            "157587": 1,
            "170789": 1,
            "175864": 1,
            "177279": 1,
            "97288": 1,
            "178776": 1,
            "157588": 1,
            "170790": 1,
            "175866": 1,
            "177281": 1
        },
        // targetAoid contains skus that are in-warranty and post-warranty - these are used in the render method logic to determine which coupon displays 
        targetAoid:  {
            "97289": 1,
            "178775": 1,
            "157587": 1,
            "170789": 1,
            "175864": 1,
            "177279": 1,
            "97288": 1,
            "178776": 1,
            "157588": 1,
            "170790": 1,
            "175866": 1,
            "177281": 1,
            "77488": 1,
            "167787": 1,
            "170791": 1,
            "175865": 1,
            "177280": 1,
        }
    }
}

export default withRouter(CarepackPromo);

